import { Form, Modal, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { SaveButton } from "~/components/buttons/SaveButton.jsx";
import { SluitButton } from "~/components/buttons/SluitButton.jsx";
import { VerwijderButtonConfirm } from "~/components/buttons/VerwijderButtonConfirm.jsx";
import { $t } from "~/i18n.js";
import { DienstTemplate } from "./dienstTemplate.jsx";
import { RegistrationListTemplate } from "./registrationListTemplate.jsx";
import { ChecklistTemplateEditor } from "./checklistTemplateEditor.jsx";
import { Input } from "antd";
import { Switch } from "antd";
import { FlightLocationFields } from "../addDay/FlightLocationFields.jsx";
import { message } from "antd";

export function DayTemplateModal({
  club,
  visible,
  onCancel,
  onOk,
  onDelete,
  confirmLoading,
  activeTemplate,
  templateCount,
}) {
  if (!visible) return null;
  const [form] = Form.useForm();

  const [atThuisveld, setAtThuisVeld] = useState(true);
  const [vliegend, setVliegend] = useState(true);
  const [registrationLists, setRegistrationLists] = useState([]);
  const [diensten, setDiensten] = useState([]);
  const [checklistStart, setChecklistStart] = useState([]);
  const [checklistEnd, setChecklistEnd] = useState([]);

  const vliegveld = !club
    ? ""
    : club.vliegveld_icao
    ? club.vliegveld_icao
    : club.vliegveld;

  useEffect(() => {
    if (activeTemplate && !activeTemplate.is_vliegend) {
      setAtThuisVeld(false);
    } else {
      setAtThuisVeld(
        !activeTemplate ||
          !club ||
          activeTemplate.vertrek_vliegveld === vliegveld
      );
    }

    setVliegend(!activeTemplate ? true : activeTemplate?.is_vliegend);
    setRegistrationLists(activeTemplate?.registration_lists || []);
    setDiensten(activeTemplate?.diensten || []);
    setChecklistStart(activeTemplate?.checklist_start_day || []);
    setChecklistEnd(activeTemplate?.checklist_end_day || []);
  }, [activeTemplate, visible, club, vliegveld]);

  const triggerSave = async () => {
    try {
      const values = await form.validateFields();

      const vertrek_vliegveld =
        atThuisveld || !values.locatie ? vliegveld : values.locatie;

      await onOk({
        ...activeTemplate,
        ...values,
        order: activeTemplate ? activeTemplate.order : templateCount + 1,
        vertrek_vliegveld: vertrek_vliegveld || "-",
        aankomst_vliegveld: vertrek_vliegveld || "-",
        is_vliegend: vliegend,
        registration_lists: registrationLists,
        diensten: diensten,
        checklist_start_day: checklistStart,
        checklist_end_day: checklistEnd,
      });

      form.resetFields();
    } catch (error) {
      message.error($t("Je mist een veld om op te slaan, bekijk de drie tabbladen goed."));
    }
  };

  return (
    <Modal
      width={750}
      title={
        activeTemplate
          ? $t("Bewerk dag template")
          : $t("Voeg nieuwe dag template toe")
      }
      open={visible}
      onCancel={onCancel}
      footer={[
        activeTemplate && (
          <VerwijderButtonConfirm
            key="1"
            loading={confirmLoading}
            onConfirm={() => onDelete && onDelete(activeTemplate.id)}
          />
        ),
        <SaveButton
          key="opslaan"
          onClick={triggerSave}
          loading={confirmLoading}
        />,
        <SluitButton key="sluit" onClick={onCancel} />,
      ]}
    >
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            key: "1",
            label: $t("Details"),
            children: (
              <Form
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                name="dayTemplateForm"
                preserve={false}
                requiredMark={false}
                initialValues={{
                  name: "",
                  description: "",
                  is_vliegend: true,
                  start_methode: "lier",
                  locatie: vliegveld,
                  ...activeTemplate,
                }}
              >
                <Form.Item
                  label={$t("Naam")}
                  name="name"
                  rules={[
                    { required: true, message: $t("Naam is verplicht!") },
                    {
                      max: 200,
                      message: $t("Maximaal ${c} characters", { c: 200 }),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label={$t("Beschrijving")}
                  name="description"
                  rules={[
                    {
                      max: 400,
                      message: $t("Maximaal ${c} characters", { c: 400 }),
                      required: false,
                    },
                  ]}
                >
                  <Input.TextArea rows={3} />
                </Form.Item>

                <Form.Item label={$t("Vliegend")} name="is_vliegend">
                  <Switch
                    onChange={(checked) => setVliegend(checked)}
                    checked={vliegend}
                    checkedChildren={$t("Ja")}
                    unCheckedChildren={$t("Nee")}
                  />
                </Form.Item>

                <FlightLocationFields
                  vliegend={vliegend}
                  atThuisveld={atThuisveld}
                  setAtThuisVeld={setAtThuisVeld}
                  vliegveld={vliegveld}
                  onSelectAirport={(airportCode) => {
                    form.setFieldsValue({ locatie: airportCode });
                  }}
                />
              </Form>
            ),
          },
          {
            key: "2",
            label: $t("Diensten"),
            children: (
              <DienstTemplate
                hasAutofill={false}
                value={diensten}
                onChange={setDiensten}
              />
            ),
          },
          {
            key: "3",
            label: $t("Registratielijsten"),
            children: (
              <RegistrationListTemplate
                value={registrationLists}
                onChange={setRegistrationLists}
              />
            ),
          },
          {
            key: "4",
            label: $t("Checklists"),
            children: (
              <div>
                <p className="bold" style={{ marginBottom: 6 }}>{$t("Start van de dag")}</p>
                <ChecklistTemplateEditor
                  value={checklistStart}
                  onChange={setChecklistStart}
                />
                <p className="bold" style={{ marginTop: 16, marginBottom: 6 }}>{$t("Einde van de dag")}</p>
                <ChecklistTemplateEditor
                  value={checklistEnd}
                  onChange={setChecklistEnd}
                />
              </div>
            ),
          },
        ]}
      />
    </Modal>
  );
}
